export const PALIA_CATEGORIES = [
    "Foraging",
    "Mining",
    "Fishing",
    "Bug Catching",
    "Cooking",
    "Crafting",
    "Gardening",
    "Ranching",
    "Hunting",
    "Housing",
    "Quests",
    "NPCs",
    "Items",
    "Locations",
    "Events",
    "Money Making",
    "Strategy",
    "Other",
];
